import AsyncStorage from "@react-native-async-storage/async-storage";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useToast } from "native-base";
import { Alert } from "react-native";

import Toast from "@/components/atoms/Toast";
import { useAppDispatch } from "@/hooks/application/store";
import { ApiError } from "@/interfaces/common/Error";
import { loginRequest } from "@/services/api/login";
import { logger } from "@/services/logger";
import { persistor } from "@/store";
import { LOGIN, LOGOUT } from "@/store/ducks/auth";

export const useLogin = () => {
  const toast = useToast();

  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: loginRequest,
    onSuccess: (data) => {
      dispatch(LOGIN(data.usuario));
    },
    onError: (error: AxiosError<ApiError>) => {
      if (error.response.status === 400) {
        toast.show({
          render: () => <Toast variant="error" message={error.response.data.error} />,
        });
      } else {
        logger.error(error);
        Alert.alert("Erro no sistema", "Tente novamente mais tarde");
      }
    },
  });
};

export const useLogout = () => {
  const dispatch = useAppDispatch();

  const logout = async () => {
    dispatch(LOGOUT());
    await AsyncStorage.clear();
    persistor.purge();
  };

  return {
    logout,
  };
};
